import ReactPaginate from "react-paginate";
import { memo } from "react";
import "./Pagination.scss";
import PropTypes from "prop-types";

const Pagination = ({
	breakLabel,
	nextLabel,
	previousLabel,
	pageCount,
	onPageChange,
	currentPage,
	marginPagesDisplayed,
	pageRangeDisplayed,
}) => {
	return (
		<ReactPaginate
			previousLabel={previousLabel}
			nextLabel={nextLabel}
			breakLabel={breakLabel}
			pageCount={pageCount}
			marginPagesDisplayed={marginPagesDisplayed}
			pageRangeDisplayed={pageRangeDisplayed}
			onPageChange={onPageChange}
			containerClassName={"pagination"}
			activeClassName={"pagination__link--active"}
			forcePage={currentPage - 1}
			disabledClassName={"pagination__link--disabled"}
		/>
	);
};

Pagination.propTypes = {
	breakLabel: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
	nextLabel: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
	previousLabel: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
	pageCount: PropTypes.number.isRequired,
	onPageChange: PropTypes.func.isRequired,
	currentPage: PropTypes.number.isRequired,
	marginPagesDisplayed: PropTypes.number.isRequired,
	pageRangeDisplayed: PropTypes.number.isRequired,
};

export default memo(Pagination);
